<template>
  <div class="appPage">
    <transition :name="transitionName" :mode="transitionMode">
      <div class="appWrapper" :key="$route.fullPath" data-theme="">
        <navbar v-if="topNav && isRouterAlive" :isTabs="isTab" :pageNames="pageTitle" :backColors="backColor" :rightType="rightTitle" :pathUrl="pathUrl" :theme="theme"></navbar>
        <router-view v-if="isRouterAlive" :class="{ 'has-nav': topNav }" />
      </div>
    </transition>
    <tabbar v-if="isTab && isRouterAlive" :actives="path"></tabbar>
  </div>
</template>
<script>
import '../public/rem'
import '../public/normalize.css'
import navbar from '@/components/navbar.vue'
import tabbar from '@/components/tabbar.vue'
import { mapState } from 'vuex'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    }
  },
  components: { navbar, tabbar },
  data() {
    return {
      isRouterAlive: true,
      isTab: true,
      topNav: true,
      theme: 'light',
      backColor: '',
      path: '',
      pathUrl: '',
      transitionName: 'fade',
      routeHistory: [],
    }
  },
  computed: {
    ...mapState(['LOADING']),
    pageTitle() {
      const titleKey = this.$route && this.$route.meta ? this.$route.meta.title : ''
      return titleKey ? this.$t(titleKey) : ''
    },
    rightTitle() {
      const rightKey = this.$route && this.$route.meta ? this.$route.meta.rightType : ''
      return rightKey ? this.$t(rightKey) : ''
    },
    transitionMode() {
      return this.transitionName === 'fade' ? 'out-in' : ''
    },
  },
  //监听器
  watch: {
    $route(to, from) {
      this.isTab = to.meta.isTab ? true : false
      this.topNav = to.meta.topNav ? true : false
      this.theme = to.meta.theme || 'light'
      this.backColor = to.meta.backColor
      this.path = to.path
      this.pathUrl = to.meta.pathUrl

      // Transition Logic
      const toPath = to.path
      if (this.routeHistory.length > 1 && this.routeHistory[this.routeHistory.length - 2] === toPath) {
        this.transitionName = 'slide-right'
        this.routeHistory.pop()
      } else {
        this.transitionName = 'slide-left'
        this.routeHistory.push(toPath)
      }

      if (this.pageTitle) {
        document.title = this.pageTitle
      }
    },
    '$i18n.locale'() {
      if (this.pageTitle) {
        document.title = this.pageTitle
      }
    },
  },
  created() {
    if (!localStorage.getItem('transactionType')) {
      localStorage.setItem('transactionType', 1)
    }
    localStorage.setItem('rate', JSON.stringify({ name: 1, a: 1 }))
    if (this.pageTitle) {
      document.title = this.pageTitle
    }
  },
  methods: {
    // 页面局部刷新
    reload() {
      this.isRouterAlive = false //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true //再打开
      })
    },
  },
}
</script>
<style lang="scss">
@font-face {
  font-family: 'SweiFistLegCJKsc';
  src: url('./assets/font/SweiFistLegCJKsc-DemiLight-2.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.van-toast--loading {
  background-color: rgba(0, 0, 0, 0) !important;
}

.van-toast__loading {
  color: #000000 !important;
}

body {
  // font-family: 'SweiFistLegCJKsc', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
  font-family: 'PingFang SC', 'Microsoft YaHei', Roboto, system-ui, -apple-system, Arial, sans-serif !important;
  background-color: #fff;
  color: #000000;
  font-size: 14px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 隐藏全局滚动条 */
::-webkit-scrollbar {
  display: none;
}

.page {
  width: 100vw;
  min-height: calc(100vh - 46px);
  box-sizing: border-box;

  .redColor {
    color: #d74e5a;
  }

  .greenColor {
    color: #12b886;
  }

  .redBackgroudColor {
    background-color: #f14940;
  }

  .greenBackgroudColor {
    background-color: #12b886;
  }

  .yellowBackgroudColor {
    background-color: #d3be1e;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

input,
button,
div,
a {
  box-sizing: border-box;
  border: none;
  background-color: transparent;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  padding: 0;
  height: 30px;
  color: #ffffff;
  background: #1989fa;
}

.router-link-active {
  text-decoration: none;
  color: #000000;
}

a {
  text-decoration: none;
  color: #000000;
}

.popBox {
  position: fixed;
  width: 100vw;
  bottom: 0;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px 10px 0 0;

  .popBox-tit {
    text-align: center;
    font-size: 15px;
    margin-bottom: 40px;
  }

  .popBox-msg {
    font-size: 12px;
    color: #999999;
  }

  .popBox-list {
    margin-top: 10px;
    max-height: 60vh;
    overflow: auto;

    .popBox-list-item {
      border: 1px solid #8bc318;
      margin-bottom: 10px;
      padding: 15px 20px;
      border-radius: 10px;
      text-align: center;

      :nth-child(1) {
        margin-bottom: 10px;
        font-size: 14px;
      }

      :nth-child(2) {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
}

.depositDialog {
  .van-dialog__header {
    padding-top: 15px;
    font-weight: 600;
  }

  .van-dialog__message {
    padding-top: 20px;
  }

  .van-dialog__confirm {
    color: #3867ff;
  }
}

.appPage {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
}

.appWrapper {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  /* Ensure background covers underlying page */
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  will-change: transform;
  z-index: 1;
}

/* Adjust top for pages with navbar - NOT NEEDED anymore if navbar is inside wrapper */
/*
.has-nav.slide-left-enter-active,
...
*/

.slide-left-enter {
  transform: translateX(100%);
}

.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter {
  transform: translateX(-100%);
}

.slide-right-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.skeleton-box {
  border-radius: 4px;
  background-color: #f5f7fa;
  background-image: linear-gradient(90deg, #f5f7fa 0%, #e4e7ed 50%, #f5f7fa 100%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 2s infinite linear;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: -150% 0;
  }

  100% {
    background-position: 150% 0;
  }
}
</style>
